import React, { useState, useEffect } from "react";
import { uploadAndSaveImage } from "../../functions/AddImage";
import { db } from "../../firebase";
import { doc, getDoc } from "firebase/firestore";

const SECTIONS = [
  { key: "hero", label: "Hero" },
  { key: "exploreIndia", label: "Explore India" },
  { key: "exploreWorld", label: "Explore World" },
  { key: "romanticGetaways", label: "Romantic Getaways" },
  { key: "ladakhBikeTrips", label: "Ladakh Bike Trips" },
  { key: "backpackTrips", label: "Backpack Trips" },
  { key: "destinationPage", label: "Destination Page Image" },
  { key: "enquiryPage", label: "Enquiry Page" },
  { key: "bannerImage", label: "Banner Image" },
];

const initialImages = SECTIONS.reduce((acc, section) => {
  acc[section.key] = { file: null, preview: null, current: null, uploading: false, error: null };
  return acc;
}, {});

const DEFAULT_CLOUD_NAME = "your_cloud_name";
const DEFAULT_UPLOAD_PRESET = "your_upload_preset";

const ImageUpdate = () => {
  const [images, setImages] = useState(initialImages);
  const [cloudName, setCloudName] = useState(DEFAULT_CLOUD_NAME);
  const [uploadPreset, setUploadPreset] = useState(DEFAULT_UPLOAD_PRESET);

  // Fetch current images from Firestore on mount
  useEffect(() => {
    async function fetchCurrentImages() {
      try {
        const docRef = doc(db, "Images", "AllImages");
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          const data = docSnap.data();
          setImages(prev =>
            Object.fromEntries(
              SECTIONS.map(({ key, label }) => [
                key,
                {
                  ...prev[key],
                  current: data[label]?.url || null,
                },
              ])
            )
          );
        }
      } catch (error) {
        // Optionally handle error
      }
    }
    fetchCurrentImages();
  }, []);

  const handleFileChange = (e, key) => {
    const file = e.target.files[0];
    if (file) {
      const preview = URL.createObjectURL(file);
      setImages((prev) => ({
        ...prev,
        [key]: { ...prev[key], file, preview, error: null }
      }));
    }
  };

  const handleUpload = async (key) => {
    const file = images[key].file;
    if (!file) return;
    if (!cloudName.trim() || !uploadPreset.trim()) {
      window.alert("Please enter your Cloudinary Cloud Name and Upload Preset before uploading.");
      return;
    }
    setImages((prev) => ({
      ...prev,
      [key]: { ...prev[key], uploading: true, error: null }
    }));
    try {
      const sectionLabel = SECTIONS.find(s => s.key === key)?.label || key;
      const url = await uploadAndSaveImage(file, sectionLabel, cloudName, uploadPreset);
      setImages((prev) => ({
        ...prev,
        [key]: { ...prev[key], current: url, file: null, preview: null, uploading: false, error: null }
      }));
    } catch (err) {
      setImages((prev) => ({
        ...prev,
        [key]: { ...prev[key], uploading: false, error: "Upload failed. Please try again." }
      }));
    }
  };

  return (
    <div className="image-update-section fadeIn">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2 className="mb-0">Update Section Images</h2>
        <div style={{ display: "flex", gap: "1.5rem", alignItems: "center" }}>
          <label htmlFor="cloudNameInput" className="form-label mb-0" style={{ fontSize: "1.1rem", minWidth: 100 }}>Cloud Name</label>
          <input
            id="cloudNameInput"
            type="text"
            className="form-control"
            style={{ width: 220, fontSize: "1.1rem", height: "2.5rem" }}
            value={cloudName}
            onChange={e => setCloudName(e.target.value)}
            placeholder="Cloud Name"
            title="Cloudinary Cloud Name"
          />
          <label htmlFor="uploadPresetInput" className="form-label mb-0" style={{ fontSize: "1.1rem", minWidth: 70 }}>Preset</label>
          <input
            id="uploadPresetInput"
            type="text"
            className="form-control"
            style={{ width: 220, fontSize: "1.1rem", height: "2.5rem" }}
            value={uploadPreset}
            onChange={e => setUploadPreset(e.target.value)}
            placeholder="Preset"
            title="Cloudinary Upload Preset"
          />
        </div>
      </div>
      <div className="row">
        {SECTIONS.map(({ key, label }) => (
          <div className="col-md-6 mb-4" key={key}>
            <div className="card h-100">
              <div className="card-header">
                <strong>{label}</strong>
              </div>
              <div className="card-body">
                <div className="mb-2">
                  <label className="form-label">Current Image:</label>
                  <div>
                    {images[key].current ? (
                      <img src={images[key].current} alt={label} style={{ maxWidth: "100%", maxHeight: 120 }} />
                    ) : (
                      <span className="text-muted">No image uploaded</span>
                    )}
                  </div>
                </div>
                <div className="mb-2">
                  <label className="form-label">Select New Image:</label>
                  <input
                    type="file"
                    accept="image/*"
                    className="form-control"
                    onChange={(e) => handleFileChange(e, key)}
                  />
                </div>
                {images[key].preview && (
                  <div className="mb-2">
                    <label className="form-label">Preview:</label>
                    <div>
                      <img src={images[key].preview} alt="Preview" style={{ maxWidth: "100%", maxHeight: 120 }} />
                    </div>
                  </div>
                )}
                {images[key].error && (
                  <div className="alert alert-danger py-1">{images[key].error}</div>
                )}
                <button
                  className="btn btn-primary"
                  disabled={!images[key].file || images[key].uploading}
                  onClick={() => handleUpload(key)}
                >
                  {images[key].uploading ? "Uploading..." : "Upload"}
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ImageUpdate;
